import jalali from 'jalaali-js'
import _ from 'lodash'
import DateObject from 'react-date-object'

export function formatDate(date: Date | string | number): string {
  date = _.isNumber(date) ? new Date(date * 1000) : new Date(date)
  const j = jalali.toJalaali(date)
  const y = _.padStart(j.jy.toString(), 4, '0')
  const m = _.padStart(j.jm.toString(), 2, '0')
  const d = _.padStart(j.jd.toString(), 2, '0')
  const h = _.padStart(date.getHours().toString(), 2, '0')
  const mi = _.padStart(date.getMinutes().toString(), 2, '0')
  const s = _.padStart(date.getSeconds().toString(), 2, '0')
  return `${y}/${m}/${d} ${h}:${mi}:${s}`
}

export function formatDateOnly(date: Date | string | number): string {
  date = _.isNumber(date) ? new Date(date * 1000) : new Date(date)
  const j = jalali.toJalaali(date)
  const y = _.padStart(j.jy.toString(), 4, '0')
  const m = _.padStart(j.jm.toString(), 2, '0')
  const d = _.padStart(j.jd.toString(), 2, '0')
  return `${y}/${m}/${d}`
}

export function formatNumber(n: number): string {
  return _.round(n, 2).toLocaleString('en-US')
}

export function formatDuration(seconds: number): string {
  let secondsLeft = Math.round(seconds)

  const days = Math.floor(secondsLeft / 86400)
  secondsLeft -= days * 86400

  const hours = Math.floor(secondsLeft / 3600)
  secondsLeft -= hours * 3600

  const minutes = Math.floor(secondsLeft / 60)
  secondsLeft -= minutes * 60

  let text = ''
  if (days) text += days + 'd '
  if (hours) text += hours + 'h '
  if (minutes) text += minutes + 'm '
  if (secondsLeft) text += secondsLeft + 's '

  return text.trimEnd()
}

export function formatDateObject(dateInSeconds: number) {
  return new DateObject(dateInSeconds * 1000).format('YYYY/MM/DD HH:mm:ss')
}

export function formatDurationSince(unixSeconds: number): string {
  if (!unixSeconds) return '-'
  const now = new Date().getTime() / 1000
  const diff = now - unixSeconds || now
  return formatDuration(diff)
}
